export default __webpack_public_path__ + "images/793dc2608ae395b3ab44fcaaf386bb01-great-for-groups.webp";